// LAKA — Conversion tracking helper for Google Ads (AW-17706438594)
// NOTE: only real commercial actions are tracked as conversions.
// Simple page visits are NOT reported as conversions.
//
// Once you create the dedicated conversions in Google Ads
// (Tools → Conversions → New conversion → Website),
// replace each placeholder label below with the real one you get,
// e.g. 'AW-17706438594/AbCdEfGhIjK'.

const GOOGLE_ADS_ID = "AW-17706438594";

// Conversion labels — REPLACE these when you create conversions in Google Ads UI.
// Until replaced, events still fire as `gtag('event', 'phone_click')` etc.
// (visible in GA4 / Google Ads diagnostic) but won't count as conversions yet.
const CONVERSIONS = {
  phone_click: null, // e.g. `${GOOGLE_ADS_ID}/AbCdEfGhIjK`
  email_click: null,
  whatsapp_click: null,
  form_submit: null,
};

function safeGtag(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    try {
      window.gtag(...args);
    } catch (e) {
      // silent
    }
  }
}

function fireConversion(eventName, extra = {}) {
  // Always fire the named event (so you can see it in GA4/Ads diagnostic)
  safeGtag("event", eventName, extra);

  // If a conversion label is set, fire a Google Ads conversion too
  const label = CONVERSIONS[eventName];
  if (label) {
    safeGtag("event", "conversion", {
      send_to: label,
      value: extra.value || 1.0,
      currency: extra.currency || "EUR",
    });
  }
}

export const trackPhoneClick = (source = "site") =>
  fireConversion("phone_click", { source });

export const trackEmailClick = (source = "site") =>
  fireConversion("email_click", { source });

export const trackWhatsAppClick = (source = "site") =>
  fireConversion("whatsapp_click", { source });

export const trackFormSubmit = (formName = "contact") =>
  fireConversion("form_submit", { form: formName });
